import { action, makeObservable, observable } from 'mobx';
import { RootStore } from './root';
import { extractErrorKeyByErrorCode } from '../utils/errorHandler';

export class ActionElementStore {
  private readonly rootStore: RootStore;

  status: 'error' | 'success';
  showMessage: boolean;
  messageContent: string;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      status: observable,
      showMessage: observable,
      messageContent: observable,
      onActionCompleted: action.bound,
      onHideMessage: action.bound,
    });
  }

  /**
   * `errorContext` picks the code channel's own copy for an error, where it
   * has one (see extractErrorKeyByErrorCode).
   */
  onActionCompleted(errorCode: string | undefined, errorContext: string) {
    this.status = errorCode ? 'error' : 'success';
    this.showMessage = true;
    this.messageContent = this.rootStore.i18n.t(
      errorCode
        ? extractErrorKeyByErrorCode(errorCode, { context: errorContext })
        : 'enter_code.resend_code_tooltip_notification',
    );
  }

  onHideMessage() {
    this.showMessage = false;
    this.messageContent = '';
  }
}
